export const ASSETS_CLIENT_ERROR_CODES = [
  'VALIDATION_FAILED',
  'PREPARE_FAILED',
  'UPLOAD_FAILED',
  'COMPLETE_FAILED',
  'LIST_FAILED',
  'GET_FAILED',
  'UPDATE_FAILED',
  'DELETE_FAILED',
  'UNKNOWN_ERROR',
] as const;

export type AssetsClientErrorCode = (typeof ASSETS_CLIENT_ERROR_CODES)[number];

export class AssetsClientError extends Error {
  readonly code: AssetsClientErrorCode;
  readonly details?: unknown;

  constructor(args: {
    code: AssetsClientErrorCode;
    message: string;
    details?: unknown;
    cause?: unknown;
  }) {
    super(args.message, { cause: args.cause });
    this.name = 'AssetsClientError';
    this.code = args.code;
    this.details = args.details;
  }
}

export function toAssetsClientError(args: {
  code: AssetsClientErrorCode;
  message: string;
  cause: unknown;
  details?: unknown;
}): AssetsClientError {
  if (args.cause instanceof AssetsClientError) {
    return args.cause;
  }

  if (args.cause instanceof Error) {
    return new AssetsClientError({
      code: args.code,
      message: args.cause.message || args.message,
      details: args.details,
      cause: args.cause,
    });
  }

  return new AssetsClientError({
    code: args.code,
    message: args.message,
    details: args.details,
    cause: args.cause,
  });
}
